<ion-content>
  <ion-grid *ngIf="!currentReview" class="ion-padding">
    <ion-row>
      <ion-col class="ion-text-center">
        <ion-spinner></ion-spinner>
      </ion-col>
    </ion-row>
  </ion-grid>

  <ion-card class="rating-card" *ngIf="currentReview">
    <ion-card-header class="rating-card__header">
      <ion-card-title
        style="font-size: 1.2rem"
        mode="md"
        *ngIf="currentReview.order_id"
      >
        {{ "orders.order-rating-modal.rate-order" | translate }} #{{
          currentReview.order_id
        }}
      </ion-card-title>
      <ion-button (click)="closeModal()" size="small" fill="clear" color="dark">
        <ion-icon slot="icon-only" src="assets/ionicons/close.svg"></ion-icon>
      </ion-button>
    </ion-card-header>

    <ion-card-content>
      <ion-list *ngIf="currentReview.storeAnswer" class="rating-card__list">
        <ion-item-divider mode="ios">
          <ion-text class="ion-text-center rating-card__divider-text">
            {{ "ratings.modals.rating-details.stores-answer" | translate }}
          </ion-text>
        </ion-item-divider>
        <ion-item lines="none">
          <ion-label class="ion-text-wrap">
            {{ currentReview.storeAnswer }}
          </ion-label>
        </ion-item>
        <ion-item-divider mode="ios" *ngIf="currentReview.timestamp">
          <ion-text class="ion-text-center rating-card__divider-text">
            {{ "ratings.modals.rating-details.rated-at" | translate }}
            {{ currentReview.timestamp | date : "d/M/yyyy, HH:mm" }}
          </ion-text>
        </ion-item-divider>
      </ion-list>

      <ion-list *ngIf="currentReview.questions" class="rating-card__list">
        <ion-item
          lines="none"
          class="rating-summary"
          *ngIf="reviewStarAverageDisplay"
        >
          <ion-grid>
            <ion-row>
              <ion-col size="12">
                <div class="rating-summary__average-row">
                  <div class="rating-summary__average">
                    {{ reviewStarAverageDisplay }}
                  </div>
                  <div class="rating-summary__icons">
                    <ion-icon
                      *ngFor="let icon of averageStarIcons"
                      [name]="icon"
                      [color]="averageColor || 'medium'"
                      class="rating-summary__icon"
                    ></ion-icon>
                  </div>
                </div>
                <ion-text
                  color="medium"
                  class="rating-summary__count"
                  *ngIf="ratingQuestionsCount"
                >
                  {{ "ratings.modals.rating-details.based-on" | translate }}
                  {{ ratingQuestionsCount }}
                  {{ "ratings.modals.rating-details.questions" | translate }}
                </ion-text>
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-item>

        <div *ngFor="let question of currentReview.questions; let idx = index">
          <!-- Align non-star items padding to match star items -->
          <ion-item
            *ngIf="
              question.type !== 'stars' &&
              (question.required ||
                (question.type === 'textarea' && question.inputted_text) ||
                (question.type === 'checkbox' && question.answers.length > 0) ||
                (question.type === 'radio' && question.answer_id))
            "
            lines="none"
            class="rating-question"
          >
            <ion-row
              style="width: 100%"
              class="ion-align-items-center ion-justify-content-center"
            >
              <ion-col size="12"
                ><strong class="question-title">{{
                  question.text_translations
                    ? (question.text_translations[selectedLanguage]
                      ? question.text_translations[selectedLanguage]
                      : (question.text_translations[mo_base]
                        ? question.text_translations[mo_base]
                        : question.text))
                    : question.text
                }}</strong>
              </ion-col>
              <ion-col size="12">
                <!--checkbox answer-->
                <ion-label
                  *ngIf="
                    question.type === 'checkbox' &&
                    question.answers &&
                    question.answers.length > 0
                  "
                >
                  <ion-text *ngFor="let answer of question.answers">
                    <p *ngIf="answer.id === question.answer_id">
                      <strong>{{
                        answer.text_translations
                          ? (answer.text_translations[selectedLanguage]
                            ? answer.text_translations[selectedLanguage]
                            : (answer.text_translations[mo_base]
                              ? answer.text_translations[mo_base]
                              : answer.text))
                          : answer.text
                      }}</strong>
                    </p>
                  </ion-text>
                </ion-label>

                <!--radio answer-->
                <ion-text
                  class="ion-no-padding"
                  *ngIf="question.type === 'radio'"
                >
                  <ion-text *ngFor="let answer of question.answers">
                    <p *ngIf="answer.id === question.answer_id">
                      <strong>{{
                        answer.text_translations
                          ? (answer.text_translations[selectedLanguage]
                            ? answer.text_translations[selectedLanguage]
                            : (answer.text_translations[mo_base]
                              ? answer.text_translations[mo_base]
                              : answer.text))
                          : answer.text
                      }}</strong>
                    </p>
                  </ion-text>
                </ion-text>

                <!--text answer-->
                <ion-label
                  *ngIf="question.type === 'textarea'"
                  style="white-space: initial"
                >
                  <strong>{{ question.inputted_text }}</strong>
                </ion-label>
              </ion-col>
            </ion-row>
          </ion-item>
          <ion-item
            *ngIf="question.type === 'stars'"
            lines="none"
            class="rating-question"
          >
            <ion-grid>
              <!-- Unified mobile-like layout: title on top, bar below on all screens -->
              <ion-row class="rating-question__header ion-align-items-center">
                <ion-col size="12" sizeMd="12">
                  <ion-text>
                    <p>
                      <strong class="question-title">{{
                        question.text_translations
                          ? (question.text_translations[selectedLanguage]
                            ? question.text_translations[selectedLanguage]
                            : (question.text_translations[mo_base]
                              ? question.text_translations[mo_base]
                              : question.text))
                          : question.text
                      }}</strong>
                    </p>
                  </ion-text>
                </ion-col>
                <ion-col size="12" sizeMd="12">
                  <div class="rating-question__progress-row">
                    <ion-progress-bar
                      class="rating-question__progress"
                      [color]="starQuestionDetails[idx]?.color || 'medium'"
                      [value]="
                        animateProgress
                          ? starQuestionDetails[idx]?.progress || 0
                          : 0
                      "
                    ></ion-progress-bar>
                    <span class="rating-question__progress-score">
                      <strong>{{
                        starQuestionDetails[idx]?.formattedValue
                      }}</strong>
                      <span class="rating-question__out-of">/ 5</span>
                    </span>
                  </div>
                </ion-col>
              </ion-row>
            </ion-grid>
          </ion-item>
        </div>
      </ion-list>
    </ion-card-content>
  </ion-card>
</ion-content>
